export const NATIVE_CLIENT_ID = 'dbz-ccg';
export const NATIVE_SCHEME = 'cc.tosche-station.dbz';
const callbackPath = '/auth/callback';
let redirectAttempt:Promise<boolean>|null=null;

/** These public PKCE values stay in the current browser URL; no session is stored here. */
export function nativeAuthQuery(search=location.search):Record<string,string> {
  const params=new URLSearchParams(search);
  if(params.get('client_id')!==NATIVE_CLIENT_ID||!/^[A-Za-z0-9]{16}$/.test(params.get('state')??'')||!/^[A-Za-z0-9_-]{43}$/.test(params.get('code_challenge')??''))return {};
  return {client_id:NATIVE_CLIENT_ID,state:params.get('state')!,code_challenge:params.get('code_challenge')!};
}
export function isNativeAuthRequest(){return Object.keys(nativeAuthQuery()).length===3;}
export function withNativeAuthQuery(path:string,search=location.search){
  if(!['/api/auth/email-otp/send-verification-otp','/api/auth/sign-in/email-otp'].includes(path))throw new Error('Only sign-in requests may preserve desktop authorization parameters.');
  const query=new URLSearchParams(nativeAuthQuery(search)).toString();
  return query?`${path}?${query}`:path;
}

/** Run on initial browser load and after OTP sign-in. False means the browser still needs sign-in. */
export async function handleNativeAuthRedirect():Promise<boolean> {
  if(!/^https?:$/.test(location.protocol)||!isNativeAuthRequest())return false;
  if(redirectAttempt)return redirectAttempt;
  redirectAttempt=(async()=>{
    // The desktop renderer never loads or constructs a browser auth client.
    const [{createAuthClient},{electronProxyClient}]=await Promise.all([import('better-auth/client'),import('@better-auth/electron/proxy')]);
    const client=createAuthClient({baseURL:location.origin,plugins:[electronProxyClient({clientID:NATIVE_CLIENT_ID,protocol:{scheme:NATIVE_SCHEME},callbackPath})]});
    const session=await client.getSession();
    if(session.error)throw new Error('Your sign-in could not be checked. Retry to return to the desktop app.');
    if(!session.data?.user)return false;
    const transfer=await client.electron.transferUser({fetchOptions:{query:nativeAuthQuery()}});
    if(transfer.error)throw new Error(transfer.error.message??'Desktop sign-in could not be completed.');
    if(!client.electron.getAuthorizationCode())throw new Error('Your browser did not accept the desktop sign-in cookie. Retry sign-in.');
    client.ensureElectronRedirect();
    return true;
  })();
  try {const redirected=await redirectAttempt;if(!redirected)redirectAttempt=null;return redirected;}
  catch(error){redirectAttempt=null;throw error;}
}
